import React from "react";

const Content = () => {
  return (
    <div class="row px-3">
        <div class="col-lg-4 mb-4">
            <div class="card p-2">
                <div class="d-flex align-items-end row">
                    <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                        <h5 class="card-title text-primary">GUEST</h5>
                        <h2 class="card-title">0</h2>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-end align-items-center">
                        <i class='bx bxs-user' style={{fontSize:50, opacity:0.3}}></i>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 mb-4">
            <div class="card p-2">
                <div class="d-flex align-items-end row">
                    <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                        <h5 class="card-title text-primary">BOOKING</h5>
                        <h2 class="card-title">0</h2>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-end align-items-center">
                        <i class='bx bxs-spreadsheet' style={{fontSize:50, opacity:0.3}}></i>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 mb-4">
            <div class="card p-2">
                <div class="d-flex align-items-end row">
                    <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                        <h5 class="card-title text-primary">ITEM</h5>
                        <h2 class="card-title">0</h2>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-end align-items-center">
                        <i class='bx bxs-barcode' style={{fontSize:50, opacity:0.3}}></i>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Content;
